import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useQuery } from '../query-context';
import { fetchAutocorrection, sanitizeLanguage, shouldFetchAutocorrection, useAutocorrectionEnabled } from './autocorrection-helper-functions';
import { useTypedAggregatorClient } from '../aggregator-client-context';
var NO_CORRECTION = [];
var AutocorrectionContext = /*#__PURE__*/createContext({
  correction: undefined,
  setCorrection: function setCorrection() {}
});
export var AutocorrectionProvider = function AutocorrectionProvider(_ref) {
  var children = _ref.children;
  var _useAutocorrectionEna = useAutocorrectionEnabled(),
    autocorrectionEnabled = _useAutocorrectionEna.autocorrectionEnabled;
  var _useState = useState(NO_CORRECTION),
    _useState2 = _slicedToArray(_useState, 2),
    correction = _useState2[0],
    setCorrection = _useState2[1];
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  var lang = sanitizeLanguage(locale);
  var aggregatorClient = useTypedAggregatorClient();
  var _aggregatorClient$get = aggregatorClient.getAggregatorConfig(),
    aggregatorUrl = _aggregatorClient$get.url,
    cloudId = _aggregatorClient$get.cloudId;
  useEffect(function () {
    setCorrection(NO_CORRECTION);
    if (autocorrectionEnabled && shouldFetchAutocorrection(query)) {
      fetchAutocorrection({
        query: query,
        aggregatorUrl: aggregatorUrl,
        lang: lang,
        cloudId: cloudId
      }).then(function (result) {
        if (!!result.termCorrections) {
          setCorrection(result.termCorrections);
        }
      }).catch(function (_error_) {});
    }
  }, [autocorrectionEnabled, query, aggregatorUrl, cloudId, lang]);
  return /*#__PURE__*/React.createElement(AutocorrectionContext.Provider, {
    value: {
      correction: correction,
      setCorrection: setCorrection
    }
  }, children);
};
export var useAutocorrection = function useAutocorrection() {
  return useContext(AutocorrectionContext);
};